if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            /* 
             FJS 
            */
            
            // Verificar si el producto tiene la etiqueta "hair"
            const productTags = this.productElement.getAttribute('data-product-tags');
            const hasHairTag = productTags && productTags.split(', ').some(tag => tag.toLowerCase() === 'hair');

            const mediaWrappers = this.productElement.querySelectorAll('.grid__item.product__media-wrapper');
            mediaWrappers.forEach(wrapper => wrapper.classList.add('hidden'));     
                    
            // Quitar la clase 'h1' de cualquier elemento dentro del modal
            const h1Elements = this.modalContent.querySelectorAll('.h1');
            h1Elements.forEach(element => element.classList.remove('h1'));
        
            // Agregar la clase 'hidden' a los elementos con la clase 'product__view-details'
            const viewDetailsElements = this.modalContent.querySelectorAll('.product__view-details');
            viewDetailsElements.forEach(element => element.classList.add('hidden'));
        
            // Crear una nueva estructura de columnas
            const columnContainer = document.createElement('div');
            columnContainer.classList.add('product__column-container');
            const leftColumn = document.createElement('div');
            leftColumn.classList.add('product__left-column');
            const rightColumn = document.createElement('div');
            rightColumn.classList.add('product__right-column');
        
            // Mover el elemento 'product__media media' a la columna izquierda
            const productMediaElement = this.modalContent.querySelector('.product__media.media');
            if (productMediaElement) {
              leftColumn.appendChild(productMediaElement);
            }
        
            // Mover los elementos 'product__title' y 'product__smallprice' a la columna derecha
            const productTitleElement = this.modalContent.querySelector('.product__title');
            const productSmallPriceElement = this.modalContent.querySelector('.product__smallprice');
            if (productTitleElement) {
              rightColumn.appendChild(productTitleElement);
            }
            if (productSmallPriceElement) {
              rightColumn.appendChild(productSmallPriceElement);
            }
        
            // Agregar las columnas al contenedor de columnas
            columnContainer.appendChild(leftColumn);
            columnContainer.appendChild(rightColumn);
        
            // Obtener el elemento de referencia (variant-selects)
            const variantSelectsElement = this.modalContent.querySelector('variant-selects');
        
            // Mover el contenedor de columnas antes de variant-selects
            if (variantSelectsElement) {
              variantSelectsElement.parentNode.insertBefore(columnContainer, variantSelectsElement);
            }
        
            // Crear un elemento de encabezado con el texto "Select Options"
            const headerElement = document.createElement('div');
            headerElement.classList.add('product__header');
            headerElement.textContent = 'Select Options';
        
            // Obtener el elemento de referencia (product__info-wrapper grid__item)
            const infoWrapperElement = this.modalContent.querySelector('.product__info-wrapper.grid__item');
        
            // Insertar el elemento de encabezado antes del elemento de referencia
            if (infoWrapperElement) {
              infoWrapperElement.parentNode.insertBefore(headerElement, infoWrapperElement);
            }
        
            // Crear un contenedor para el contenido del pie del modal
            const footerContainer = document.createElement('div');
            footerContainer.classList.add('product__footer-container');
        
            // Mover los elementos 'product__price' y 'product-add' al contenedor del pie del modal
            const productPriceElement = this.modalContent.querySelector('.product__price');
            const productAddElement = this.modalContent.querySelector('.product-add');
            if (productAddElement) {
              footerContainer.appendChild(productAddElement);
            }
            if (productPriceElement) {
              footerContainer.appendChild(productPriceElement);
            }

            // Agregar la clase 'hidden' al div con la clase 'carousel-indicators'
            const carouselIndicatorsDiv = this.modalContent.querySelector('.carousel-indicators');
            if (carouselIndicatorsDiv) {
              carouselIndicatorsDiv.classList.add('hidden');
            }

            // Obtener el contenedor 'product' y agregar el 'footerContainer' dentro de él
            const productContainer = this.modalContent.querySelector('.product');
            if (productContainer) {
              productContainer.appendChild(footerContainer);
            }

            this.applyZoomedClass(hasHairTag);
            /* end FJS */

            super.show(opener);

            /* FJS */  
            const modalContentElement = this.querySelector('.quick-add-modal__content');
            if (modalContentElement) {
              modalContentElement.classList.add('quick-add-modal__content--animate');
            }

          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            // fjs
            setupModals();
            
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      // FJS
      applyZoomedClass(hasHairTag) {
        const mediaImages = this.modalContent.querySelectorAll('.product__media img');      
        mediaImages.forEach((img) => {
          img.classList.remove('image-magnify-none', 'zoomed');
          img.classList.add(hasHairTag ? 'zoomed' : 'image-magnify-none');
        });
      }

    }
  );
}
